// utils/nezoApp.js
//
// Which Nezo to send people back to. There is ONE Ops Console, used by both staging and prod Nezo, so
// the sign-on (components/NezoSso.js) remembers the Nezo the user came from (the gateway puts it in the
// one-time code). Only known Nezo web apps are accepted; anything else falls back to prod.

const DEFAULT_NEZO_APP_URL = (process.env.REACT_APP_NEZO_APP_URL || 'https://app.nezo-app.com').replace(/\/+$/, '');
const STORAGE_KEY = 'nezoAppUrl';

export function isAllowedNezoAppUrl(url) {
  if (typeof url !== 'string') return false;
  return /^https:\/\/(app|staging)\.nezo-app\.com$/.test(url) || /^http:\/\/localhost(:\d{2,5})?$/.test(url);
}

export function setNezoAppUrl(url) {
  const clean = typeof url === 'string' ? url.trim().replace(/\/+$/, '') : '';
  if (!isAllowedNezoAppUrl(clean)) return;
  try { localStorage.setItem(STORAGE_KEY, clean); } catch { /* private mode etc. — the prod default still works */ }
}

export function getNezoAppUrl() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (isAllowedNezoAppUrl(stored)) return stored;
  } catch { /* ignore */ }
  return DEFAULT_NEZO_APP_URL;
}

const NEZO_APP_BY_ENVIRONMENT = {
  staging: 'https://staging.nezo-app.com',
  prod: 'https://app.nezo-app.com',
};

/**
 * The Nezo a material lives in. A material made from staging Nezo exists ONLY in staging (its
 * `Environment` column), so it must open there whatever Nezo the user last came from; untagged
 * materials are in both, so they follow the user's own Nezo. A local dev Nezo always wins.
 */
export function nezoAppUrlFor(environment) {
  const own = getNezoAppUrl();
  if (/^http:\/\/localhost/.test(own)) return own;
  return NEZO_APP_BY_ENVIRONMENT[String(environment || '').toLowerCase()] || own;
}

/**
 * Open a material in Nezo. Nezo's /goto/material page hands it to an already-open Nezo tab that is on a
 * project (which shows it as ready to map), or else opens the Materials page with it highlighted.
 */
export function gotoMaterialUrl(quantityUnitId, regionId, name, environment) {
  const qs = new URLSearchParams();
  if (regionId) qs.set('region', regionId);
  if (name) qs.set('name', name);
  const q = qs.toString();
  return `${nezoAppUrlFor(environment)}/goto/material/${encodeURIComponent(quantityUnitId)}${q ? `?${q}` : ''}`;
}
